// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import './assets/js/dialog'

import './permission.js' // permission control



import XrAvatar from '@/components/XrAvatar'
import XrButton from './components/XrButton/index'
import XrIcon from './components/XrIcon/index'
import XrLayout from './components/XrLayout/index'
import XrPageSelect from './components/XrPageSelect/index'
import XrCollapse from './components/XrCollapse/index'
import XrUploadSinglePicture from './components/XrUploadSinglePicture/index'
import XrTable from './components/XrTable/index'
import XrDataTable from './components/XrTable/dataTable'
import PageSelectDialog from './components/PageSelect/pageSelectDialog'
import XrUpload from './components/XrUpload/index'
import XrResource from './components/XrResource/index'
import XrResourceDialog from './components/XrResource/file-dialog'
import XrResourceImgDialog from './components/XrResource/img-dialog'
import XrMultipleSelect from './components/XrMultipleSelect/index'
import XrSelect from './components/XrSelect/index'
import XrTableSelect from './components/XrTable/table-select'
import XrTableSelectSpecial from './components/XrTable/table-select-special'
import XrFileView from './components/XrFileView/index'
import XrInputFile from './components/XrInputFile/index'
import OrgTree from './views/sys/org/org-view-tree.vue'
import XrTagAdd from './components/XrTagAdd/index'
import XrCheckbox from './components/XrCheckbox/index'
import XrMultiParamAdd from './components/XrMultiParamAdd/index'
import XrLoading from './components/XrLoading/index'
import XrUploadImp from './components/XrUploadImg/index'
import XrEditor from "./components/XrEditor";
import XrUploadFiles from './components/XrUploadFiles/index'
Vue.component('xr-avatar', XrAvatar)
Vue.component('xr-button', XrButton)
Vue.component('xr-icon', XrIcon)
Vue.component('xr-layout', XrLayout)
Vue.component('xr-page-select', XrPageSelect)
Vue.component('xr-collapse', XrCollapse)
Vue.component('xr-upload-single-picture', XrUploadSinglePicture)
Vue.component('xr-table', XrTable)
Vue.component('xr-data-table', XrDataTable)
Vue.component('page-select-dialog', PageSelectDialog)
Vue.component('xr-upload', XrUpload)
Vue.component('xr-resource', XrResource)
Vue.component('xr-resource-dialog', XrResourceDialog)
Vue.component('xr-resource-img-dialog', XrResourceImgDialog)
Vue.component('xr-multiple-select', XrMultipleSelect)
Vue.component('xr-select', XrSelect)
Vue.component('xr-table-select', XrTableSelect)
Vue.component('xr-table-select-special', XrTableSelectSpecial)
Vue.component('xr-file-view', XrFileView)
Vue.component('xr-input-file', XrInputFile)
Vue.component('xr-tag-add', XrTagAdd)
Vue.component('xr-checkbox', XrCheckbox)
Vue.component('org-tree', OrgTree)
Vue.component('xr-multi-param-add', XrMultiParamAdd)
Vue.component('xr-loading', XrLoading)
Vue.component('xr-upload-img', XrUploadImp)
Vue.component('XrEditor', XrEditor)
Vue.component('xr-upload-files', XrUploadFiles)

// openWebOfficeEdit


import request from './utils/request'

Vue.prototype.request = request

//recombinationMap
import CommonUtils from './utils/xhh/common'
Vue.prototype.CommonUtils = CommonUtils

// import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//格式化订单状态
Vue.filter('formatOrderStatus', function (orderStatus) {

  console.log(orderStatus);

  let result = '';
  if((orderStatus + '') === '1'){
    result = '订单驳回';
  }else if((orderStatus + '') === '2'){
    result = '订单待审核';
  }else if((orderStatus + '') === '3'){
    result = '订单已审核';
  }else if((orderStatus + '') === '4'){
    result = '订单已接收';
  }else if((orderStatus + '') === '5'){
    result = '订单配送中';
  }else if((orderStatus + '') === '8'){
    result = '订单已签收';
  }
  return result;
})



import router from './router'

/**挂载防止重复点击事件*/
import preventReClick from './utils/xhh/preventReClick'
Vue.use(preventReClick);

import './styles/index.scss';
import './assets/css/common.scss';
import { handleImgLoadError } from './utils/defaultImgHandler';

// 将默认图片工具类方法挂载到window，供全局作用域的onerror调用
window.handleImgLoadError = handleImgLoadError;

Vue.config.productionTip = false




/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js